import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import loading from "../../assets/seller/loading.png";
import { DeleteProductsApi, EditProductApi } from "../../ApiCalls/AddProducts";
import { toast } from "react-toastify";
import DeleteModal from "../DeleteModal/DeleteModal";

const SellerProduct = ({ fetchedProducts, refetchProducts }) => {
  const navigate = useNavigate();
  const [showConfirm, setShowConfirm] = useState(false);
  const [selectedProductId, setSelectedProductId] = useState(null);
  const handleDelete = async () => {
    if (selectedProductId?.id) {
      try {
        await DeleteProductsApi(selectedProductId.id); // API call to delete the product
        console.log("Deleting product with ID:", selectedProductId.id);
        setShowConfirm(false);
        toast.success("Product Deleted successfully!");
        refetchProducts(); // Refetch products after successful deletion
      } catch (error) {
        console.error("Error in deleting product:", error);
        toast.error("Failed to delete the product. Please try again.");
      }
    }
  };

  const handleStockStatusChange = async (productId, stockStatus) => {
    try {
      console.log("status", productId, stockStatus);
      await EditProductApi(productId, { stock_status: stockStatus }); // Send true or false directly
      refetchProducts(); // Refetch the updated products list
      alert("Stock status updated successfully!");
    } catch (error) {
      console.error("Error updating stock status:", error);
      alert("Failed to update stock status. Please try again.");
    }
  };

  return (
    <div className="h-full w-full space-y-4 p-5">
      <h1 className="mb-4 text-center text-2xl font-bold text-green-600">
        Products List{" "}
      </h1>
      <div className="flex w-full items-center justify-end">
        <button
          onClick={() => navigate("/seller/products/add_product")}
          className="mt-2 cursor-pointer rounded-lg bg-brand-button-green-bg p-2 px-5 text-lg text-white hover:scale-105"
        >
          Add Products
        </button>
      </div>
      {fetchedProducts?.Data?.length > 0 ? (
        <div className="overflow-x-auto">
          <div className="grid min-w-[800px] grid-cols-[4rem,2fr,3fr,1.5fr,1fr,1.5fr,2fr,3fr] p-2 font-medium text-brand-button-green-bg">
            <div className="text-center">Item No</div>
            <div className="text-center">Product Code</div>
            <div className="text-center">Product Name</div>
            <div className="text-center">Stock</div>
            <div className="text-center">Price</div>
            <div className="text-center">Status</div>
            <div className="text-center">Admin Status</div>
            <div className="text-center">Actions</div>
          </div>

          {fetchedProducts.Data.map((product, index) => (
            <div
              key={product.id}
              className="grid min-w-[900px] grid-cols-[4rem,2fr,3fr,1.5fr,1fr,1.5fr,2fr,3fr] items-center gap-2 p-2"
            >
              <div className="line-clamp-1 rounded border p-2 text-center hover:line-clamp-none">
                {index + 1}
              </div>
              <div className="line-clamp-1 rounded border p-2 text-center hover:line-clamp-none">
                {product.product_code}
              </div>
              <div className="line-clamp-1 rounded border p-2 text-center hover:line-clamp-none">
                {product.name}
              </div>
              <div className="line-clamp-1 rounded border p-2 text-center hover:line-clamp-none">
                {product.stock}
              </div>
              <div className="line-clamp-1 rounded border p-2 text-center hover:line-clamp-none">
                {product.price}
              </div>
              {/* <div className="line-clamp-1 rounded border p-2 text-center hover:line-clamp-none">
                {product.stock_status}
              </div> */}
              <div className="rounded border p-2 text-center">
                <select
                  value={product.stock_status ? "List" : "Unlist"} // Map boolean to human-readable values
                  onChange={
                    (e) =>
                      handleStockStatusChange(
                        product.id,
                        e.target.value === "List",
                      ) // Convert back to boolean
                  }
                  className="h-full w-full rounded-md border-gray-300 text-center outline-none"
                >
                  <option value="List">List</option>
                  <option value="Unlist">Unlist</option>
                </select>
              </div>

              <div className="line-clamp-1 rounded border p-2 text-center hover:line-clamp-none">
                {product.status}
              </div>
              <div className="flex justify-center gap-2">
                <button
                  onClick={() =>
                    navigate(`/seller/products/edit/${product.id}`)
                  }
                  className="rounded-md bg-blue-500 p-2 px-4 text-white hover:bg-blue-600"
                >
                  Edit
                </button>
                <button
                  onClick={() =>
                    navigate(`/seller/products/view/${product.id}`)
                  }
                  className="rounded-md bg-green-500 p-2 px-4 text-white hover:bg-green-600"
                >
                  View
                </button>
                <button
                  // onClick={() => handleDelete(product.id)}
                  onClick={() => {
                    setSelectedProductId(product);
                    setShowConfirm(true);
                  }}
                  className="rounded-md bg-red-500 p-2 px-4 text-white hover:bg-red-600"
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="flex h-[90%] w-full flex-col items-center justify-center">
          <img
            src={loading}
            alt="Loading"
            className="h-auto w-52 object-cover"
          />
          <h2 className="mt-4 text-2xl font-medium text-gray-700">
            No products found
          </h2>
        </div>
      )}
      {/* Delete Confirmation Modal */}
      {showConfirm && (
        <DeleteModal
          entityName="Product"
          title={selectedProductId?.name}
          onConfirm={handleDelete}
          onCancel={() => setShowConfirm(false)}
        />
      )}
    </div>
  );
};

export default SellerProduct;
